// export const AUTH = ['auth_organization_management', 'auth_sync_management', 'auth_staff_management', 'auth_login_information_confirmation'];
export const PASS = ['pass_list_user', 'pass_users_management'];
export const LOG = ['saucer_logs', 'sync_logs'];
export const PERMISSION = ['permission_role', 'permission_default_setting'];
export const MANAGEMENT = ['management_ccj_admin', 'management_auth_console_role', 'management_connect_web_services', 'management_modules'];
export const careposi = ['careposi_organization_management', 'careposi_map_management'];
